// in src/Dashboard.js
import React, { useState, useEffect } from 'react';

import axios from "axios";

import Grid from '@mui/material/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@mui/material/Typography';

import { SelectInput, TextInput, required, BooleanInput, useCreate, FormWithRedirect, SaveButton, useDataProvider, DateInput, useSetLocale } from 'react-admin';  

import { useParams } from 'react-router-dom';

import { validateMaxLength, validateEmail, validateTrue  } from '../components/Validator';

import { parse } from 'query-string';


import { useTranslate, setAssociationLang } from '../common/language';import { choicesGenderUser, targets, apiUrl } from '../common/constants';import { headersAPIObjectPublic } from '../common/utils';

import MyLoading from '../components/MyLoading';
import { CustomFieldsEdit } from '../components/CustomFields';
import { AddMemberHeader } from '../components/AddMemberHeader';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));


export const AddMember = props => {
    
  const translate = useTranslate();  
  const dataProvider = useDataProvider();
    
  const [info, setInfo] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [errorApi, setErrorApi] = useState();
  const [create] = useCreate('users/public');
  const [formSent, setFormSent] = useState();
  
  const setLocale  = useSetLocale();
  
  const { friendly_url } = useParams();
  const lastName1Label = translate(
    info?.friendly_url === 'obra-cultural-balear' ? 'users.surnames' : 'users.last_name_1'
  );
    
  const { associations_id: associations_id_string } = parse(props.location.search);
  const associations_id = associations_id_string ? parseInt(associations_id_string, 10) : '';
    
  const [open, setOpen] = React.useState(false);
  const [openLopd, setOpenLopd] = React.useState(false);

  const openErrorDialog = () => {
    setOpen(true);
  };
  const closeErrorDialog = () => {
    setOpen(false);
  };
    
  const openLopdDialog = () => {
    setOpenLopd(true);
  };
  const closeLopdDialog = () => {
    setOpenLopd(false);
  };

  useEffect(() => {
          
    let url = ''; 
    if (friendly_url)
        url = apiUrl + '/associations/public/str/' + friendly_url;        
    else
        url = apiUrl + '/associations/public/' + associations_id;    

    axios.get(url, { headers: headersAPIObjectPublic() } )
    .then((response) => {
        setInfo(response.data);
        setLoading(false);
        setError(false);    
    })
    .catch((error) => {
        // Manejar el error aquí
        console.error('Error en la solicitud:', error);
        setLoading(false);
        setError(true); // Establecer el estado de error en true        
    });
        
  }, []);
  
  
  useEffect(() => {
      if (info)
      {
          setAssociationLang(info.lang); 
      }
    }, [info]);
    
  if (loading) return <MyLoading />;
  if (error) return <center><br /><br/>{translate('add_member.association_not_found')}</center>;
  if (!info) return null;
  
       
  /*
    const htmlDecode = input => {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }*/
    
  const handleSubmit = values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {              
          setFormSent(true);
          setErrorApi('');
        },
        onFailure: ( error ) => {
          setErrorApi(error.message);
          openErrorDialog();                                    
        }
      }
    );
  };
  
  let arrFields = [];
  try {
    arrFields = JSON.parse(info.add_member_fields);  
  } catch (e) {
    console.error("JSON invàlid:", e);
  }
      
  if (formSent)
  {
    return (
      <>
      <AddMemberHeader info={info} />
      <Box sx={{ width: '90%', maxWidth: 800, bgcolor: 'background.paper', padding: '20px' }} className="add_member_box" >                        
        <div className="add_member_form_sent" dangerouslySetInnerHTML={{ __html: info.add_member_validate_email ? info.add_member_form_sent : info.add_member_confirmation }} />                                
      </Box>
      </>
    );
  }
    
  if (!info.add_member_actived)
    return <center><br /><br/>{translate('add_member.form_not_actived')}</center>;    
  else
    return (
            
      <FormWithRedirect
        resource="users"        
        save={handleSubmit}
        initialValues={{ associations_id : info.id ,
          user_type: 0
        }}
        render={formProps => (
          <>   
            <AddMemberHeader info={info} />
            <Box sx={{ width: '90%', maxWidth: 600, bgcolor: 'background.paper', padding: '20px' }} className="add_member_box" >
        
              {info.add_member_form_text ?
                <Grid item xs={12} className="justify">
                  <div dangerouslySetInnerHTML={{ __html: info.add_member_form_text }} />
                  <br />
                </Grid>
                : null }
              
            {arrFields.map(item => (
                
                <React.Fragment key={item.id}>

                  { item.actived === '1'? 
                  <>
                  
                  {item.name === "first_name" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <TextInput className="add_member_input" label={translate('users.first_name')} fullWidth source="first_name" validate={[ fieldIsRequired(item.id, arrFields) ? required() : undefined, validateMaxLength(100, translate('common.validation.maxLength'))].filter(Boolean)} />
                      </Grid>
                    </Grid>
                    )}
                    
                    {item.name === "last_name_1" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <TextInput className="add_member_input" label={lastName1Label} fullWidth source="last_name_1" validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100, translate('common.validation.maxLength'))].filter(Boolean)} />
                      </Grid>
                    </Grid>
                    )}
            
                    {item.name === "last_name_2" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <TextInput className="add_member_input" label={translate('users.last_name_2')} fullWidth source="last_name_2" validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100, translate('common.validation.maxLength'))].filter(Boolean)} />
                      </Grid>
                    </Grid>
                    )}

                    {item.name === "email" && (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                          <TextInput className="add_member_input" fullWidth source="email" label={translate('users.email')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100, translate('common.validation.maxLength')),validateEmail()].filter(Boolean)} />
                        </Grid>
                      </Grid>
                    )}

                    {item.name === "nif" && (
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                          <TextInput className="add_member_input" fullWidth source="nif" label={translate('users.nif')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(10, translate('common.validation.maxLength')) ].filter(Boolean)} />
                        </Grid>
                      </Grid>
                    )}

                    {item.name === "address" && (
                      <Grid container spacing={1}>
                          <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="address" label={translate('users.address')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(255,translate('common.validation.maxLength'))].filter(Boolean)} />
                          </Grid>                        
                      </Grid>
                    )}    
                  
                  {item.name === "neighborhood" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <TextInput className="add_member_input" fullWidth source="neighborhood" label={translate('users.neighborhood')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100,translate('common.validation.maxLength'))].filter(Boolean)} />
                      </Grid>                      
                    </Grid>
                  )}    
                  
                  {item.name === "zip" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                          <TextInput className="add_member_input" fullWidth source="zip" label={translate('users.zip')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(5,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                       
                    </Grid>
                    </>
                  )}    
                  
                  {item.name === "city" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="city" label={translate('users.city')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                     
                    </Grid>
                    </>
                  )}    
                  
                  {item.name === "region" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="region" label={translate('users.region')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                       
                    </Grid>
                    </>
                  )}    
                  
                  {item.name === "country" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="country" label={translate('users.country')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(255,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                      
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "phone" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="phone" label={translate('users.phone')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(50,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                      
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "mobile" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="mobile" label={translate('users.mobile')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(15,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                    
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "birthday" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <DateInput className="add_member_input" fullWidth source="birthday" label={translate('users.birthday')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined].filter(Boolean)} />
                        </Grid>                   
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "job" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="job" label={translate('users.job')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(100,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>               
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "gender" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <SelectInput className="add_member_input" fullWidth source="gender" choices={choicesGenderUser(translate)} optionText="name" optionValue="id" label={translate('users.gender')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined].filter(Boolean)} />    
                        </Grid>                  
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "bank_iban" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="iban" label={translate('users.bank_iban')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(32,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>                    
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "bank_swift" && (
                    <>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextInput className="add_member_input" fullWidth source="swift" label={translate('users.bank_swift')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(11,translate('common.validation.maxLength'))].filter(Boolean)} />
                        </Grid>               
                    </Grid>
                    </>
                  )}  
                  
                  {item.name === "custom_fields" && (
                    <>
                    <CustomFieldsEdit associations_id={info.id} target={targets.USER} title={false} accordion={false} only_form_web={true} />
                    </>
                  )}  
                  
                  {item.name === "comment" && (
                    <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                        <TextInput className="add_member_input" fullWidth multiline source="comment" label={translate('users.add_member_comments')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined,validateMaxLength(1000,translate('common.validation.maxLength'))].filter(Boolean)} />
                    </Grid>
                    </Grid>
                  )}         
          
                  {item.name === "newsletter" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <BooleanInput className="add_member_input" fullWidth source="newsletter" label={translate('users.newsletter')} validate={[fieldIsRequired(item.id, arrFields) ? required() : undefined].filter(Boolean)} />
                      </Grid>                      
                    </Grid>
                  )}    
          
                  {item.name === "lopd" && (
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12}>
                        <BooleanInput className="add_member_input" fullWidth source="lopd" label={<>{translate('add_member.form_lopd')} <a href='#' onClick={(e)=>{e.preventDefault(); openLopdDialog();}}>{translate('add_member.lopd')}</a></>} validate={[validateTrue(translate('add_member.form_lopd_validator'))]} />
                      </Grid>                      
                    </Grid>
                  )}  
                  
                  </>
                  : null }
                </React.Fragment>
                
              ))}
      
    
              { /*
              <Grid container spacing={1} >
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" label={translate('users.first_name')} fullWidth source="first_name" validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" label={lastName1Label} fullWidth source="last_name_1" validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" label={translate('users.last_name_2')} fullWidth source="last_name_2" validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextInput className="add_member_input" fullWidth source="email" label={translate('users.email')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength')),validateEmail()]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="nif" label={translate('users.nif')} validate={[required(),validateMaxLength(10,translate('common.validation.maxLength'))]} />
                </Grid>
              </Grid>  
                                   
              <Grid container spacing={1}>
                <Grid item xs={12} sm={8}>
                  <TextInput className="add_member_input" fullWidth source="address" label={translate('users.address')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="neighborhood" label={translate('users.neighborhood')} validate={[validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
              </Grid>
                
              <Grid container spacing={1}>     
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="zip" label={translate('users.zip')} validate={[required(),validateMaxLength(5,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="city" label={translate('users.city')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="region" label={translate('users.region')} validate={[validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>                    
              </Grid>
                   
              <Grid container spacing={1}>   
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="country" label={translate('users.country')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="phone" label={translate('users.phone')} validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="mobile" label={translate('users.mobile')} validate={[required(),validateMaxLength(15,translate('common.validation.maxLength'))]} />
                </Grid>
              </Grid>
                
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <DateInput className="add_member_input" fullWidth source="birthday" label={translate('users.birthday')} validate={[required()]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextInput className="add_member_input" fullWidth source="job" label={translate('users.job')} validate={[validateMaxLength(100,translate('common.validation.maxLength'))]} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <SelectInput className="add_member_input" fullWidth source="gender" choices={choicesGenderUser(translate)} optionText="name" optionValue="id" label={translate('users.gender')} validate={[]} />    
                </Grid>
              </Grid>  
                
              { info.add_member_bank_data ? 
                <>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={8}>
                      <TextInput className="add_member_input" fullWidth source="iban" label={translate('users.bank_iban')} validate={[required(),validateMaxLength(32,translate('common.validation.maxLength'))]} />
                    </Grid>                        
                    <Grid item xs={12} sm={4}>
                      <TextInput className="add_member_input" fullWidth source="swift" label={translate('users.bank_swift')} validate={[validateMaxLength(11,translate('common.validation.maxLength'))]} />
                    </Grid>
                  </Grid>
                </>
                    
                :
                <span />
              }
                                
              <CustomFieldsEdit associations_id={info.id} target={targets.USER} title={false} accordion={false} only_form_web={true} />
                                
              <Grid spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextInput className="add_member_input" fullWidth multiline source="comment" label={translate('users.add_member_comments')} validate={[validateMaxLength(1000,translate('common.validation.maxLength'))]} />
                </Grid>
              </Grid>
              <Grid spacing={2}>
                <Grid item xs={12}>
                  <BooleanInput className="add_member_input" fullWidth source="lopd" label={<>{translate('add_member.form_lopd')} <a href='#' onClick={(e)=>{e.preventDefault(); openLopdDialog();}}>{translate('add_member.lopd')}</a></>} validate={[validateTrue(translate('add_member.form_lopd_validator'))]} />
                </Grid>
              </Grid>
     
               */ }
                                
              <div className="add_member_button" >
                <SaveButton
                  saving={formProps.saving}
                  handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
                  label={translate('users.add_member_send')}
                  icon={<span />}
                />
              </div>

            </Box>
            <br /><br />
            
            <BootstrapDialog
              onClose={closeLopdDialog}
              aria-labelledby="customized-dialog-title"
              open={openLopd}
              fullWidth
              maxWidth="lg"
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                {translate('add_member.lopd')}   
                <IconButton
                  aria-label="close"
                  onClick={closeLopdDialog}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent>   
                <div dangerouslySetInnerHTML={{ __html: info.add_member_lopd }} />
              </DialogContent>
            </BootstrapDialog>
              
            <BootstrapDialog
              onClose={closeErrorDialog}
              aria-labelledby="customized-dialog-title"
              open={open}
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                {translate('add_member.form_title')}   
                <IconButton
                  aria-label="close"
                  onClick={closeErrorDialog}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
    
              <DialogContent dividers>
                <Typography gutterBottom>
                  {errorApi}
                </Typography>
              </DialogContent>
            </BootstrapDialog>
      
          </>
            
            
        )}
      />
        
    );
  
};

function fieldIsRequired(id, arrFields) {
  if (!Array.isArray(arrFields)) return false;
  const field = arrFields.find(item => item.id === id);
  return field ? field.required === 1 || field.required === "1" : false;
}

